/** Models */
import { Environment } from '@core/models/environment';
/** Sixense */
import { BydRuntimeService } from '@sixense/byd-lib-runtime';
import { BydRhsConfig } from '@sixense/ds-roazhon-service';
/** Enums */
import { BydRhsConfigEnum } from '@core/enums/byd-rhs-config-enum';
import { BimDataConfig } from '@core/models/bimdata-config.model';

export class BydRuntimeLoader {
  /**
   * Load the application environment configuration instanciated with
   * `BydRhsConfig` for the roahzonService.
   *
   * @static
   * @param bydRuntimeService the byd runtime service
   * @returns `BydRhsConfig`
   */
  public static roazhonConfigLoaderFn(bydRuntimeService: BydRuntimeService<Environment>): BydRhsConfig {
    const apiUrl = bydRuntimeService.environment.settings.ROAZHON_URL;
    return new BydRhsConfig({ apiUrl, apiScope: BydRhsConfigEnum.API_SCOPE });
  }

  /**
   * Load the application environment bimdata configuration.
   *
   * @param bydRuntimeService the byd runtime service
   * @returns BydNuxeoConfig
   */
  public static bimDataConfigLoaderFn(bydRuntimeService: BydRuntimeService<Environment>): BimDataConfig {
    const bimDataUrl = bydRuntimeService.environment.settings.BIMDATA_URL;
    return new BimDataConfig({ bimDataUrl, scope: BydRhsConfigEnum.BIMDATA_API_SCOPE });
  }
}
